<template>
  <b-card class="modern-ticket-card" style="margin-bottom: 25px;">
    <template #header>
      <div class="d-flex justify-content-between align-items-center">
        <b-badge variant="light" class="text-muted border shadow-sm px-3 py-2" style="font-size: 0.9rem;">
          #{{ chamado.id }}
        </b-badge>
        <span class="font-weight-bold" style="font-size: 1.05rem;">
          <b-icon icon="person-circle" class="mr-2"></b-icon>{{ formatarSolicitante(chamado.cliente.nome) }}
        </span>
      </div>
    </template>
    <b-card-text :class="tipo === 'visualizacao' ? 'mb-15' : 'mb-10'" class="ticket-description p-3">
      <div v-html="formatarDescricao(chamado.descricao)"></div>
    </b-card-text>
    <div class="d-flex justify-content-end">
      <b-button
          v-if="tipo === 'aberto'"
          href="#"
          pill
          class="font-weight-bolder text-uppercase"
          style="background: rgb(48, 63, 159)"
          @click="handleAcao"
      >
        Atender
      </b-button>
      <b-button
          v-else-if="tipo === 'em-atendimento'"
          href="#"
          variant="danger"
          pill
          class="font-weight-bolder text-uppercase"
          @click="handleAcao"
      >
        Finalizar
      </b-button>
      <b-badge
          v-else-if="tipo === 'visualizacao'"
          :variant="obterVarianteBadge(chamado)"
          class="text-white"
      >
        {{ obterTextoBadge(chamado) }}
      </b-badge>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'ChamadoCard',
  props: {
    chamado: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'aberto'
    }
  },
  methods: {
    formatarSolicitante(nomeCompleto) {
      if (!nomeCompleto) return '';
      const nomes = nomeCompleto.split(' ');
      const nomeFormatado = nomes.length > 1 ? `${nomes[0]} ${nomes[nomes.length - 1]}` : nomes[0];
      return nomeFormatado.slice(0, 20);
    },
    formatarDescricao(descricao) {
      return descricao ? descricao.replace('<br>', '') : '';
    },
    obterVarianteBadge(chamado) {
      if (chamado.finalizado) return 'success';
      return chamado.hasOperator ? 'info' : 'dark';
    },
    obterTextoBadge(chamado) {
      if (chamado.finalizado) return 'Concluído';
      return chamado.hasOperator ? 'Em atendimento' : 'Pendente';
    },
    handleAcao() {
      if (this.tipo === 'em-atendimento') {
        this.$emit('finalizar', this.chamado);
      } else if (this.tipo === 'aberto') {
        this.$emit('atender', this.chamado);
      }
    }
  }
};
</script>

<style scoped>
/* Estilos extra se necessários, o global modern-design.css cuida do resto */
</style>
